<template>
<div
  class="card"
  v-loading="saving || loading"
>
  <div class="card-header">
    <h4 class="card-title">Dados Adicionais</h4>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-md-10">
        <div class="form-group">
          <label class="control-label">Logradouro</label>
          <input
            class="form-control"
            type="text"
            name="street"
            v-validate="modelValidations.additionalData.street"
            v-model.trim="addressStreet"
            autofocus
            autocomplete="off"
          />
          <small
            class="text-danger"
            v-show="street.invalid"
          > {{ getError('street') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="control-label">Número</label>
          <input
            class="form-control"
            type="text"
            name="number"
            v-validate="modelValidations.additionalData.number"
            v-model.trim="addressNumber"
            v-mask="'000000000'"
            autocomplete="off"
          />
          <small
            class="text-danger"
            v-show="number.invalid"
          > {{ getError('number') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label">Bairro</label>
          <input
            class="form-control"
            type="text"
            name="neighborhood"
            v-validate="modelValidations.additionalData.neighborhood"
            v-model.trim="addressNeighborhood"
            autocomplete="off"
          />
          <small
            class="text-danger"
            v-show="neighborhood.invalid"
          > {{ getError('neighborhood') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Município</label>
          <select
            name="city"
            v-validate="modelValidations.additionalData.city"
            v-model="addressCity"
            class="form-control"
          >
            <option
              value=""
              disabled
            >Selecione ...
            </option>
            <option
              v-for="option in citiesOptions"
              :key="option.value"
              :value="option.value"
            >{{ option.label }}
            </option>
          </select>
          <small
            class="text-danger"
            v-show="city.invalid"
          > {{ getError('city') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="control-label">CEP</label>
          <input
            class="form-control"
            type="text"
            name="zip"
            v-validate="modelValidations.additionalData.zip"
            v-model.trim="addressZip"
            v-mask="'00000-000'"
            autocomplete="off"
          />
          <small
            class="text-danger"
            v-show="zip.invalid"
          > {{ getError('zip') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label class="control-label">Complemento</label>
          <input
            class="form-control"
            type="text"
            name="complement"
            v-validate="modelValidations.additionalData.complement"
            v-model.trim="addressComplement"
            autocomplete="off"
          />
          <small
            class="text-danger"
            v-show="complement.invalid"
          > {{ getError('complement') }}
          </small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">NIS</label>
          <input
            type="text"
            name="nis"
            v-validate="modelValidations.additionalData.nis"
            v-model.trim="nis"
            @keyup="this.nis = this.nis.replace(/\D/g, '')"
            autocomplete="off"
            :required="nisRequired"
            class="form-control"
            :maxlength="maxLengthNIS"
          >
          <small
            v-if="errorNIS"
            class="text-danger"
          > O NIS informado não é <valido></valido>
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">Método de regularização </label>
          <select
            name="city"
            v-validate="modelValidations.additionalData.regularity"
            v-model="regularity"
            class="form-control"
          >
            <option
              value=""
            >Selecione ...
            </option>
            <option value="paidAccount">Conta paga</option>
            <option value="installmentOfAccount">Parcelamento de conta</option>
            <option value="secondWayAccount">2ª via de conta</option>
            <option value="changeOfTitularity">Troca de titularidade</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer text-right">
    <button
      type="submit"
      :disabled="saving"
      @click.prevent="handleSave()"
      class="btn btn-fill btn-success btn-wd"
    >
      <i class="ti-save"></i> Salvar
    </button>
  </div>
</div>
</template>
<script>
import { mapFields } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { nisService } from '../../../services/validations'

export default {
  name: 'AdditionalDataForm',
  props: {
    customer: {
      required: false,
      type: Object
    }
  },
  data () {
    return {
      saving: false,
      addressStreet: '',
      addressNumber: '',
      addressNeighborhood: '',
      addressCity: '',
      addressZip: '',
      addressComplement: '',
      nis: '',
      regularity: '',
      maxLengthNIS: 11,
      errorNIS: false
    }
  },
  computed: {
    ...mapFields(['street', 'number', 'neighborhood', 'city', 'zip', 'complement']),
    ...mapGetters('customers', {
      modelValidations: 'validations'
    }),
    ...mapGetters('project', {
      'citiesOptions': 'citiesOptions',
      config: 'project',
      loading: 'loading'
    }),

    nisRequired: function () {
      return this.config.requiredNIS
    }
  },

  methods: {
    ...mapActions('project', {
      fetchProject: 'fetchOne'
    }),
    ...mapActions('customers', ['upsert', 'changeLoading']),
    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    handleSave () {
      this.saving = true
      this.errorNIS = !nisService.validate(this.nis)
      this.$validator.validateAll()
        .then(isValid => {
          const nisIsValid = !this.nisRequired || !this.errorNIS
          if (!isValid || !nisIsValid) {
            this.saving = false
            return
          }

          let doc = Object.assign(
            this.customer,
            {
              nis: this.nis,
              regularity: this.regularity
            },
            {
              address: {
                street: this.addressStreet,
                number: this.addressNumber,
                neighborhood: this.addressNeighborhood,
                city: this.addressCity,
                zip: this.addressZip,
                complement: this.addressComplement
              }
            }
          )

          delete doc.tickets
          delete doc.lamps

          this.changeLoading(true)
          this.upsert(doc)
            .then(() => {
              this.saving = false
              this.$notify({ message: 'Dados salvos com sucesso.', type: 'success' })
              this.changeLoading(false)
              this.$emit('on-save')
            })
            .catch(() => {
              this.saving = false
              this.changeLoading(false)
              this.$emit('on-save')
            })
        })
        .catch(() => {
          this.saving = false
          this.changeLoading(false)
        })
    },

    onlyNumber (text) {
      if (text === 'nis') this.nis = this.nis.replace(/\D/g, '')
    }
  },

  mounted () {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config')
    }
    this.addressStreet = this.customer.address.street
    this.addressNumber = this.customer.address.number
    this.addressNeighborhood = this.customer.address.neighborhood
    this.addressCity = this.customer.address.city
    this.addressZip = this.customer.address.zip
    this.addressComplement = this.customer.address.complement

    this.nis = this.customer.nis
    this.regularity = this.customer.regularity
    this.modelValidations.additionalData.nis.required = this.nisRequired
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/Customers/Forms/AdditionalDataForm.vue